module.exports = __webpack_public_path__ + "images/sgp/featuredContentImages/sharing-unit-with-friend.webp";